import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./WorkingSteps.css";

gsap.registerPlugin(ScrollTrigger);

export default function Workingsteps({ steps }) {
  const containerRef = useRef(null);
  const fillRef = useRef(null);
  const leftRefs = useRef([]);
  const rightRefs = useRef([]);

  const setLeftRef = (el, i) => (leftRefs.current[i] = el);
  const setRightRef = (el, i) => (rightRefs.current[i] = el);

  useEffect(() => {
    if (!containerRef.current) return;

    const stepsCount = steps.length;
    const firstPercent = (1 / stepsCount) * 100;

    // Initial line + hidden steps
    gsap.set(fillRef.current, { height: `${firstPercent}%` });
    gsap.set(leftRefs.current.slice(1), { autoAlpha: 0, y: 60 });
    gsap.set(rightRefs.current.slice(1), { autoAlpha: 0, y: 60 });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: containerRef.current,
        start: "top top",
        end: "+=300%",
        scrub: true,
        pin: true,
      },
    });

    for (let i = 1; i < stepsCount; i++) {
      const targetPercent = ((i + 1) / stepsCount) * 100;

      tl.to(
        fillRef.current,
        { height: `${targetPercent}%`, ease: "none", duration: 1 },
        i
      );
      tl.to(
        [leftRefs.current[i], rightRefs.current[i]],
        {
          autoAlpha: 1,
          y: 0,
          duration: 0.8,
          ease: "power3.out",
        },
        i + 0.2
      );
    }

    return () => {
      if (tl.scrollTrigger) tl.scrollTrigger.kill();
      tl.kill();
      ScrollTrigger.getAll().forEach((t) => t.kill());
    };
  }, [steps]);

  return (
    <section ref={containerRef} className="workingsteps-container">
      <div className="workingsteps-wrapper">
        <div className="workingsteps-content">
          {/* Center Line */}
          <div className="workingsteps-line-container">
            <div className="workingsteps-line-bg">
              <div ref={fillRef} className="workingsteps-line-fill" />
            </div>
          </div>

          {/* Steps */}
          <div className="workingsteps-steps">
            {steps.map((s, i) => {
              const isEven = i % 2 === 1;
              return (
                <div key={i} className="workingsteps-row">
                  <div
                    ref={(el) => setLeftRef(el, i)}
                    className={`workingsteps-side ${
                      isEven ? "image-side" : "text-side"
                    }`}
                  >
                    {!isEven ? (
                      <>
                        <h1 className="step-number">{s.step}</h1>
                        <h3 className="step-title">{s.title}</h3>
                        <p className="step-desc">{s.desc}</p>
                      </>
                    ) : (
                      <img src={s.img} alt="" className="step-image" />
                    )}
                  </div>

                  <div
                    ref={(el) => setRightRef(el, i)}
                    className={`workingsteps-side ${
                      isEven ? "text-side" : "image-side"
                    }`}
                  >
                    {isEven ? (
                      <>
                        <h1 className="step-number">{s.step}</h1>
                        <h3 className="step-title">{s.title}</h3>
                        <p className="step-desc">{s.desc}</p>
                      </>
                    ) : (
                      <img src={s.img} alt="" className="step-image" />
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
